export const map = <T, Result>(data: T | undefined | null, mapper: (data: T) => Result): Result | null => {
    if (!data) return null;
    return mapper(data);
};
